/*
 * @Author: your name
 * @Date: 2021-03-11 09:21:16
 * @LastEditTime: 2021-06-28 10:20:26
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \zlt-front-end\src\Master\api\common.js
 */
import request from '../../utils/request'

//登录
export function loginRequest(data) {
    return request({
        url: '/auth/account/webLogin',
        method: 'post',
        data
    })
}

//是否可以登陆
export function getIsLongin(data) {
    return request({
        url: '/auth/account/getIsLongin',
        method: 'get',
        
    })
}
// 注册
export function registered(data) {
    return request({
        url: '/auth/account/regist',
        method: 'post',
        data
    })
}

// 手机验证码
export function phoneRequest(data) {
    return request({
        url: '/auth/account/verificationCode',
        method: 'post',
        data
    })
}
// TAS登陆
export function tasRequest(data) {
    return request({
        url: '/auth/account/webLogin',
        method: 'post',
        data
    })
}
// 获取im账号
export function queryByUser(data) {
    return request({
        url: '/im/business-im/queryByUserCodeOrgCode',
        method: 'post',
        data
    })
}

// 绑定微信账号
export function bindingWeChat(data) {
    return request({
        url: `/auth/account/bindingWeChat`,
        method: 'get',
        params:data
    })
}

//修改密码
export function setPw(data) {
    return request({
        url: '/auth/account/setPw',
        method: 'post',
        data
    })
}

//修改密码
export function resetPw(data) {
    return request({
        url: '/auth/account/resetPw',
        method: 'post',
        data
    })
}



//查询当前登录人信息 并提示

export function tipsSearch(data) {
    return request({
        url: `/auth/account/tipsSearch`,
        method: 'get',
        params:data
    })
}


export function ContractStatus(data) {
    return request({
        url: `/contract/fdd/callBack/ContractStatus?transaction_id=90089f9f6d01480f9cd810f9611111&contract_id=DJ210926X111&result_code=3000000`,
        method: 'post',
    })
}


/*
    海报广场相关
*/

//数据解析
export function getShareData(data) {
    return request({
        url: `/product/eshop/srm/share/getShareData/${data.codeType}/${data.parseCode}`,
        method: 'get',
    })
}

//获取二维码Id
export function getORCode(data) {
    return request({
        url: `/external/sns/getORCode`,
        method: 'post',
        data
    })
}

//保存综合海报
export function saveProductSquare(data) {
    return request({
        url: `/product/eshop/srm/square/saveProductsquare`,
        method: 'post',
        data
    })
}

//更新综合海报
export function updateProductSquare(data) {
    return request({
        url: `/product/eshop/srm/square/updateProductsquare`,
        method: 'post',
        data
    })
}

//查询综合海报详情
export function queryProductSquare(data) {
    return request({
        url: `/product/eshop/srm/square/selectProductsquare`,
        method: 'post',
        data
    })
}
//删除综合海报
export function deleteProductSquare(data) {
    return request({
        url: `/product/eshop/srm/square/deleteProductsquare`,
        method: 'post',
        data
    })
}









// WEBPACK FOOTER //
// ./src/Master/api/common.js